import Message from 'maeng-utils/locale'
import React from 'react'

const SoftSkill = () => {
  return (
    <section className="mb-14">
      <Message
        i18nKey="portfolio.softSkill.title"
        className="text-2xl font-semibold mb-6"
        component="h4"
      />
      <ul>
        <Message
          i18nKey="portfolio.softSkill.details"
          className="text-lg leading-8 check-list"
          component="li"
          values={{
            b: <b className="font-semibold highlight-[#ffaf1933]" />,
          }}
        />
      </ul>
    </section>
  )
}

export default SoftSkill
